/*
 * Copyright (c) 2019. 42 bv (www.42.nl). All rights reserved.
 */

"use strict";

/**
 * @ngdoc directive
 * @name diceApp.factory:errorFieldsStore
 * @description Provides callbacks whenever an error occurs.
 */
angular.module("diceApp").factory("valueChecker", function () {
  return { isEmpty };

  function isEmpty(value) {
    if (_.isArray(value) || _.isObject(value) || _.isString(value)) {
      return _.isEmpty(value);
    } else if (_.isFunction(value)) {
      return !!value();
    } else {
      return _.isUndefined(value) || _.isNull(value);
    }
  }
});
